import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { fileUrl } from "../Tools/APIs";
import "./SectionSwiper/styles.css";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import ProMemberCard from "./Cards/ProMemberCard";
import LoadingMembersCard from "./Cards/LoadingMembersCard";
import { Col } from "../Tools/Grid-system";
import { avatars } from "../Context/lists";

function SectionSwiperPro({ data, isLoading }) {
  return (
    <div className="rounded-2xl">
      <Swiper
        slidesPerView={3}
        pagination={{ clickable: true }}
        modules={[Pagination]}
        className="mySwiper custom-swiper !p-3"
        breakpoints={{
          1020: { slidesPerView: 3 },
          767: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
      >
        {(isLoading ? [1, 2, 3, 4] : data?.slice(0, 7))?.map((e, i) => (
          <SwiperSlide key={i}>
            <Col key={e?.login_details?.id || i} className="!p-3">
              {isLoading ? (
                <LoadingMembersCard />
              ) : (
                <ProMemberCard
                  isOnline={e?.is_online}
                  id={e?.login_details?.id}
                  image={
                    e?.images?.length > 0
                      ? fileUrl + e.images[e.images.length - 1].image
                      : e?.avatar_id
                      ? avatars.filter((ele) => ele.id === e?.avatar_id)[0]?.img
                      : ""
                  }
                  isCaring={e.is_caring}
                  name={e?.login_details?.username || e?.secret_data?.name}
                  age={e?.social_status?.age}
                  status={e?.social_status?.social_status?.name}
                  city={e?.nationality_residence?.city?.name}
                  job={e?.study_work?.job?.name}
                  user={e}
                  country={e?.nationality_residence?.country?.name}
                />
              )}
            </Col>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default SectionSwiperPro; 